import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  makeStyles, Paper, BottomNavigation, BottomNavigationAction,
} from '@material-ui/core';

import DescriptionIcon from '@material-ui/icons/Description';
import ShuffleIcon from '@material-ui/icons/Shuffle';
import MapIcon from '@material-ui/icons/Map';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import ReplayIcon from '@material-ui/icons/Replay';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

import { devicesActions, sessionActions } from '../store';
import { useTranslation } from '../LocalizationProvider';
import { api_call, console_log, getToken, setToken } from '../helpers/untils';

const useStyles = makeStyles((theme) => ({
  container: {
    bottom: theme.spacing(0),
    left: '0px',
    width: '100%',
    position: 'fixed',
    zIndex: 1301,
    [theme.breakpoints.up('lg')]: {
      left: theme.spacing(1.5),
      bottom: theme.spacing(1.5),
      width: theme.dimensions.drawerWidthDesktop,
    },
  },
  bottomItem: {
    minWidth: '50px'
  }
}));

const BottomMenu = () => {
  const classes = useStyles();
  const history = useHistory();
  const t = useTranslation();

  const dispatch = useDispatch();

  const applyLogout = async () => {
    window.localStorage.removeItem('session');
    dispatch(sessionActions.updateUser({ id: 0 }));

    const m_token = getToken();
    if (m_token) {
      const url = `/api/auth`
      const response = await api_call(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      setToken("")
    }
    history.push('/login');
  }

  const handleSelection = (_, value) => {
    console_log("value:::", value)
    switch (value) {
      case 0:
        window.location.href = "/main" // window.location.reload(true)
        break;
      case 1:
        history.push('/replay');
        break;
      case 2:
        dispatch(devicesActions.setSelectedDeviceId(null));
        history.push('/reports/commands');
        break;
      case 3:
        history.push('/settings/turo-trips');
        break;
      case 4:
        applyLogout()
        break;
      default:
        break;
    }
  };

  return (
    <Paper square elevation={4} className={classes.container}>
      <BottomNavigation
        value={0}
        onChange={handleSelection}
        showLabels
      >
        <BottomNavigationAction label={'Reload'} icon={<ReplayIcon />} className={classes.bottomItem} />
        <BottomNavigationAction label={'Playback'} icon={<PlayCircleOutlineIcon />} className={classes.bottomItem} />
        <BottomNavigationAction label={t('reportTitle')} icon={<DescriptionIcon />} className={classes.bottomItem} />
        <BottomNavigationAction label={t('settingsTitle')} icon={<ShuffleIcon />} className={classes.bottomItem} />
        <BottomNavigationAction label={t('loginLogout')} icon={<LogoutIcon />} className={classes.bottomItem} />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomMenu;
